import { useNavigate } from "react-router";
import Button from "../../common/buttons/button/Button";
import SectionHeader from "../sectionHeader/SectionHeader";
import "./HeroSection.css";
import { PATH_CONTACT } from "../../../utility/constants";
import Images from "../../../utility/imagePaths";

type HeroSectionProps = {
  isDetailPage?: boolean;
  sectionTitle?: string;
  headingpart1: string;
  headingpart2: string;
  description: string;
  rightComponent?: any;
};

const HeroSection = ({
  isDetailPage,
  sectionTitle,
  headingpart1,
  headingpart2,
  description,
  rightComponent,
}: HeroSectionProps) => {
  const navigate = useNavigate();
  return (
    <section className="heroSection_container">
      <div className={isDetailPage ? "app_detail_section" : "app_section"}>
        <div className="heroSection_left_container">
          <div
            className={
              isDetailPage
                ? "heroSection_leftHeader_container"
                : "appSection_header_container"
            }
          >
            {isDetailPage && (
              <SectionHeader
                title={sectionTitle || ""}
                style={{
                  alignSelf: "flex-start",
                  border: isDetailPage
                    ? "1px solid hsla(215, 100%, 73%, 0.111)"
                    : "1px solid hsl(214 84% 56%)",
                }}
              />
            )}
            <h1 className={"heroSection_title"}>
              {headingpart1}{" "}
              <span className="gradient_text">{headingpart2} </span>
            </h1>
            <p
              className={
                isDetailPage ? "heroSection_description" : "section_description"
              }
            >
              {description}
            </p>
          </div>
          {isDetailPage && (
            <Button
              title={isDetailPage ? "Start Your Project" : "Get Started"}
              onClickButton={() => navigate(PATH_CONTACT)}
              backgroundColor="linear-gradient(135deg, hsl(214 84% 56%), hsl(263 70% 50%))"
              className="heroGetStart_btn "
              rightComponent={
                <img
                  src={Images.SVG_ARROW_RIGHT_WHITE_ICON}
                  alt="arrow white"
                  className="heroGetStart_arrow_right_white"
                />
              }
            />
          )}
        </div>
        {rightComponent && rightComponent}
      </div>
    </section>
  );
};

export default HeroSection;
